export const DEPENDENCIES_FLYOUT_TYPE = 'DEPENDENCIES_FLYOUT' as const;
export const CONTEXT_MENU_TYPE = 'CONTEXT_MENU' as const;
